<template>
  <div class="checkbox">
    <input
      v-if="!loading"
      type="checkbox"
      name="checkbox"
      :class="'checkbox-button'"
      v-model="dado.selecionado"
      @change="handleSeleciona"
    />
    <label
      for="checkbox"
      :class="['checkbox-custom', estiloClasse, { 'loading-check': loading }]"
      >{{ estiloCheck }}</label
    >
  </div>
</template>

<script lang="js">
export default {
    name: 'CheckButton',

    props: {
      loading: Boolean,
      seleciona: Function,
      posicao: Number,
      dado: Object,
      classe: String,
    },

    data() {
        return {
        }
    },
    computed: {
      estiloClasse() {
        if (this.dado.selecionado) {
          return this.classe
        }
        return
      },
      estiloCheck() {
        if (this.dado.selecionado) {
          return '✓'
        }
        return
      }
    },
    methods: {
        handleSeleciona: function () {
          this.seleciona(this.dado.id_imposto)
        },
    },
}
</script>

<style scoped lang="scss">
.checkbox {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 1.1rem;
  height: 1.1rem;
  padding-top: 0.5rem;
}
.checkbox-button {
  height: 17px;
  width: 17px;
  z-index: 10;
  opacity: 0;
  cursor: pointer;
}
.checkbox-custom {
  position: absolute;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  line-height: 13px;
  color: var(--branco);
}

.preferencia_tarifaria,
.class_importacao {
  background: var(--importacao);
}

.pis_cofins,
.cide_combustivel {
  background: var(--pis-cofins);
}

.icms_interno,
.icms_st,
.carga_liquida,
.antecipacao,
.difal {
  background: var(--icms);
}

.ipi {
  background: var(--ipi);
}

.loading-check {
  opacity: 0.3;
  cursor: not-allowed !important;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media only print {
  .checkbox {
    display: none;
  }
}
</style>
